import fetch from '../../utils/fetch'

export function sendCoupon(params) {
    return fetch({
        url: '/api/bussinessCoupon/bussinessSendCoupon',
        method: 'POST',
        data: params
    })
}
//预付券查询优惠规则
export function listFeescale(params) {
    return fetch({
        url: `/api/feescale/selectList`,
        method: 'GET',
        params:params 
    })
}
